import React from "react";
import { makeStyles, Button, Box } from "@material-ui/core";
import AA from "../assets/images/AA.jpg";
import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleChangeLogoModal } from "../reducers/UiReducer";
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    backgroundColor: "white",
    marginBottom: 5,
    width: "100%",
    borderRadius: 25,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      marginBottom: 16,
    },
  },
  InputPropsStyle: {
    backgroundColor: "white",
    borderRadius: 25,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "#ee8622",
    color: "white",
    borderRadius: 2,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "#39c9bb",
    },
  },
}));
const LoginForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [tabvalue, setValue] = React.useState(0);
  const handleFormSubmit = (data, actions) => {
    // history.push("/fd");
    dispatch(toggleChangeLogoModal(true))
    setTimeout(() => {
      dispatch(toggleChangeLogoModal(false))
      history.push("/fd")
    }, 1200);
    
  };
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      onSubmit={handleFormSubmit}
    >
      {({ submitForm, isSubmitting, values, errors }) => (
        <>
          <Form>
            <>
              <Box
                onClick={() => history.push("/")}
                style={{ cursor: "pointer" }}
              >
                <img src={AA} style={{ height: 60 }}></img>
                <span
                  style={{
                    color: "#8b0000f2",
                    fontSize: "30px",
                    fontWeight: 600,
                    fontFamily: "cursive",
                  }}
                >
                  Arya Aviation
                </span>
              </Box>
              {tabvalue === 0 && (
                <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Login
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email ID"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    autocomplete="off"
                    name="password"
                    type="password"
                    variant="outlined"
                    label="Password"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={handleFormSubmit}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    LOGIN
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}} onClick={async () => {
									await setValue(2);
									// validateForm(values);
								}}>Forgot Password?</p>
                    <p style={{cursor:'pointer'}}  onClick={async () => {
									await setValue(1);
									// validateForm(values);
								}}>Register Now</p>
                  </Box>
                </>
              )}
              {tabvalue===1&&  <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Registration
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Company Name"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Name"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Phone"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Password"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={() => history.push("/fd")}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    REGISTER
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}} onClick={async () => {
									await setValue(0);
									// validateForm(values);
								}}>Already have an account? Log In</p>
                  </Box>
                </>}
                {tabvalue === 2 && (
                <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Forgot Password
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={() => history.push("/fd")}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    FORGOT PASSWORD
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}}onClick={async () => {
									await setValue(0);
									// validateForm(values);
								}}>Already have an account? Log In</p>
                  </Box>
                </>
              )}
            </>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default LoginForm;
